import { useLanguage } from '../context/LanguageContext'
import { t } from '../i18n/translations'

// Compact control that hides/shows each text version across all lesson cards.
// The available versions follow the language picked on the welcome screen.
export default function ShowTextToggle() {
  const { textVisibility, toggleTextVisibility, textVersions } = useLanguage()

  return (
    <div className="show-text-filter" role="group" aria-label={t('showText')}>
      <span className="show-text-label">{t('showText')}</span>
      {textVersions.map(v => {
        const on = !!textVisibility[v.key]
        return (
          <button
            key={v.key}
            type="button"
            className={`show-text-btn ${on ? 'active' : ''}`}
            aria-pressed={on}
            onClick={e => {
              e.stopPropagation()
              toggleTextVisibility(v.key)
            }}
          >
            {v.label}
          </button>
        )
      })}
    </div>
  )
}
